import { ActionIcon, Group, Text, Tooltip } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

interface PageControlsProps {
  page: number;
  pageSize: number;
  shown: number;
  hasMore: boolean;
  onPageChange: (page: number) => void;
}

/**
 * The API returns a page without a total count, so navigation is
 * previous/next rather than a numbered pager.
 */
export function PageControls({ page, pageSize, shown, hasMore, onPageChange }: PageControlsProps) {
  const first = shown === 0 ? 0 : page * pageSize + 1;
  const last = page * pageSize + shown;

  return (
    <Group justify="space-between">
      <Text size="xs" c="dimmed">
        {shown === 0 ? 'Ничего не найдено' : `Показаны ${first}–${last}`}
      </Text>

      <Group gap="xs">
        <Tooltip label="Предыдущая страница" withArrow>
          <ActionIcon
            variant="default"
            aria-label="Предыдущая страница"
            disabled={page === 0}
            onClick={() => onPageChange(page - 1)}
          >
            <IconChevronLeft size={16} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        <Tooltip label="Следующая страница" withArrow>
          <ActionIcon
            variant="default"
            aria-label="Следующая страница"
            disabled={!hasMore}
            onClick={() => onPageChange(page + 1)}
          >
            <IconChevronRight size={16} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
      </Group>
    </Group>
  );
}
